import { useAccount } from 'wagmi';

export const useExplorerLink = ({
  address,
  txHash,
}: {
  address?: string;
  txHash?: string;
}): string | undefined => {
  const { chain } = useAccount();
  if (!chain?.blockExplorers || !txHash) {
    return undefined;
  }

  const explorerUrl = chain.blockExplorers.default.url;
  return address ? `${explorerUrl}/address/${address}` : `${explorerUrl}/tx/${txHash}`;
};
